import ScrollTop from "components/ScrollTop";
import Router from "routes/Router";
import Theme from "themes";
import "./styles/mui.css";

import { AppProvider } from "contexts/AppContext";
import { ReactNotifications } from "react-notifications-component";

function App() {
  return (
    <>
      <ReactNotifications />
      <AppProvider>
        <Theme>
          <ScrollTop>
            <Router />
          </ScrollTop>
        </Theme>
      </AppProvider>
    </>
  );
}

export default App;
